/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Whatyoullreceive2Inputs */

const id_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang akan Anda terima:`)
};

const ms_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang anda akan terima:`)
};

const da_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad du vil modtage:`)
};

const de_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was Sie erhalten werden:`)
};

const en_us2_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you'll receive:`)
};

const es_es2_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que recibirás:`)
};

const es_mx2_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que recibirás:`)
};

const fil_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano ang matatanggap mo:`)
};

const fr_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que vous recevrez :`)
};

const it_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa riceverai:`)
};

const hu_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit fogsz kapni:`)
};

const nl_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat je ontvangt:`)
};

const no_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva du vil motta:`)
};

const pl_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co otrzymasz:`)
};

const pt_br2_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que você receberá:`)
};

const pt_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que receberá:`)
};

const ro_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce vei primi:`)
};

const fi_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä saat:`)
};

const sv_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad du får:`)
};

const vi_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn sẽ nhận được:`)
};

const tr_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alacaklarınız:`)
};

const cs_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co budete dostávat:`)
};

const bg_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какво ще получавате:`)
};

const ru_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что вы будете получать:`)
};

const uk_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Що ви отримуватимете:`)
};

const ar_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما ستتلقاه:`)
};

const hi_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको क्या मिलेगा:`)
};

const th_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่คุณจะได้รับ:`)
};

const ja_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受け取れるもの：`)
};

const zh_cn2_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您将收到：`)
};

const zh_hant1_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您將收到：`)
};

const ko_notifications_whatyoullreceive2 = /** @type {(inputs: Notifications_Whatyoullreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`받게 될 알림:`)
};

/**
* | output |
* | --- |
* | "What you'll receive:" |
*
* @param {Notifications_Whatyoullreceive2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_whatyoullreceive2 = /** @type {((inputs?: Notifications_Whatyoullreceive2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Whatyoullreceive2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_whatyoullreceive2(inputs)
	if (locale === "ms") return ms_notifications_whatyoullreceive2(inputs)
	if (locale === "da") return da_notifications_whatyoullreceive2(inputs)
	if (locale === "de") return de_notifications_whatyoullreceive2(inputs)
	if (locale === "en-US") return en_us2_notifications_whatyoullreceive2(inputs)
	if (locale === "es-ES") return es_es2_notifications_whatyoullreceive2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_whatyoullreceive2(inputs)
	if (locale === "fil") return fil_notifications_whatyoullreceive2(inputs)
	if (locale === "fr") return fr_notifications_whatyoullreceive2(inputs)
	if (locale === "it") return it_notifications_whatyoullreceive2(inputs)
	if (locale === "hu") return hu_notifications_whatyoullreceive2(inputs)
	if (locale === "nl") return nl_notifications_whatyoullreceive2(inputs)
	if (locale === "no") return no_notifications_whatyoullreceive2(inputs)
	if (locale === "pl") return pl_notifications_whatyoullreceive2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_whatyoullreceive2(inputs)
	if (locale === "pt") return pt_notifications_whatyoullreceive2(inputs)
	if (locale === "ro") return ro_notifications_whatyoullreceive2(inputs)
	if (locale === "fi") return fi_notifications_whatyoullreceive2(inputs)
	if (locale === "sv") return sv_notifications_whatyoullreceive2(inputs)
	if (locale === "vi") return vi_notifications_whatyoullreceive2(inputs)
	if (locale === "tr") return tr_notifications_whatyoullreceive2(inputs)
	if (locale === "cs") return cs_notifications_whatyoullreceive2(inputs)
	if (locale === "bg") return bg_notifications_whatyoullreceive2(inputs)
	if (locale === "ru") return ru_notifications_whatyoullreceive2(inputs)
	if (locale === "uk") return uk_notifications_whatyoullreceive2(inputs)
	if (locale === "ar") return ar_notifications_whatyoullreceive2(inputs)
	if (locale === "hi") return hi_notifications_whatyoullreceive2(inputs)
	if (locale === "th") return th_notifications_whatyoullreceive2(inputs)
	if (locale === "ja") return ja_notifications_whatyoullreceive2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_whatyoullreceive2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_whatyoullreceive2(inputs)
	return ko_notifications_whatyoullreceive2(inputs)
});
export { notifications_whatyoullreceive2 as "notifications.whatYoullReceive" }